import React, { useCallback, useContext, useState } from 'react'
import { Button, NotificationManagerContext, Select, Spacer, Text, Textarea, View, ZoomProvider } from 'oio-react'
import { Link } from 'react-router-dom'
import ContainerLayout1 from 'src/components/Explore/ContainerLayout1'
import { useDebounced } from 'src/components/utils'
import FuseExploreLayout from 'src/custom/fuse/components/ExploreLayout'
import { useOrganization, useUpdateOrganization } from 'src/graphql/hooks'
import { Theme } from 'src/libraries/contexts/Theme'
import ExploreHome from 'src/pages/Explore/Home'

// =======================================================
// Container Layouts
// =======================================================

const containerLayouts = [
   null,
   ContainerLayout1,
   FuseExploreLayout
]

// =======================================================
// Component
// =======================================================

const ExploreEdit = () => {
   const { organization } = useOrganization()
   const { updateOrganization, mutating } = useUpdateOrganization()
   const { showNotification } = useContext(NotificationManagerContext)

   const [formData, setFormData] = useState({
      exploreDescription: organization.exploreDescription,
      exploreContainerLayoutKey: organization.exploreContainerLayoutKey
   })

   const defaultLayout = containerLayouts[1]
   const ContainerLayout = containerLayouts[formData.exploreContainerLayoutKey] || defaultLayout

   const debouncedUpdateFormField = useDebounced((name, value) => {
      setFormData({
         ...formData,
         [name]: value
      })
   }, 500)

   const updateFormField = useCallback((e) => {
      const field = e.currentTarget
      debouncedUpdateFormField(field.name, field.value)
   })

   const save = () => {
      updateOrganization(formData)
      .then((response) => {
         showNotification({
            message: 'Changes saved successfully',
            title: 'Success!',
            type: 'success'
         })
      })
      .catch(() => {
         showNotification({
            message: 'There was an error while saving',
            title: 'Error!',
            type: 'error'
         })
      })
   }

   return (
      <>
         <View
            position="fixed"
            top="0px"
            left="0px"
            right="0px"
            bottom="0px">
            <View
               display="flex"
               alignItems="center"
               justifyContent="space-between"
               position="absolute"
               top="0px"
               left="0px"
               height="72px"
               right="0px"
               padding="0px 30px"
               backgroundColor="#1f2329">
               <Text size="3" weight="medium" color="#fff">
                  Explore | Edit
               </Text>
               <View>
                  <Link to="/explore">
                     <Button
                        color="#888"
                        size="sm"
                        name="Close"
                        outline
                     />
                  </Link>
                  <Spacer size="1" orientation="vertical" />
                  <Button
                     onClick={save}
                     color={mutating ? '#111' : '#F0CB9E'}
                     mode={mutating ? 'loading' : 'normal'}
                     textColor="#000"
                     size="sm"
                     name="Save Changes"
                  />
               </View>
            </View>
            <View
               display="flex"
               justifyContent="center"
               position="absolute"
               top="72px"
               left="0px"
               bottom="0px"
               right="330px"
               backgroundColor="#ccc"
               paddingBottom="120px"
               scroll="on">
               <ZoomProvider zoom={0.6}>
                  <View
                     position="relative"
                     float="left"
                     width="100vw"
                     backgroundColor="#fff">
                     <ContainerLayout organizationOverride={formData}>
                        <ExploreHome />
                     </ContainerLayout>
                  </View>
               </ZoomProvider>
            </View>
            <View
               position="absolute"
               top="72px"
               right="0px"
               bottom="0px"
               width="330px"
               backgroundColor="#fff"
               padding="30px"
               zIndex="2">
               <View>
                  <View float="left" width="100%" height="12px" />
                  {formData.homeContainerLayoutKey < 2 && (
                     <>
                        <Select
                           onChange={updateFormField}
                           label="Layout"
                           name="exploreContainerLayoutKey">
                           <option value="1">Layout 1</option>
                        </Select>
                        <View float="left" width="100%" height="12px" />
                     </>
                  )}
                  <Textarea
                     onChange={updateFormField}
                     label="Explore page description"
                     name="exploreDescription"
                     rows="10"
                     defaultValue={formData.exploreDescription}
                  />
               </View>
            </View>
         </View>
         <Theme
            viewportMarginTop="0px"
            viewportMarginLeft="0px"
            globalNavIsHidden
         />
      </>
   )
}

export default ExploreEdit
